import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navigation from "./Navigation";

/**
 * Header sits at the top of every page (via Layout). It contains the
 * site logo/brand, the desktop Navigation, and a hamburger button that
 * reveals the mobile Navigation on small screens.
 */
const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMobileMenu = () => setMobileOpen((open) => !open);
  const closeMobileMenu = () => setMobileOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand" onClick={closeMobileMenu}>
          Kambham Srihari Reddy
        </Link>

        <Navigation variant="desktop" />

        <button
          className="navbar-toggle"
          aria-label="Toggle menu"
          onClick={toggleMobileMenu}
        >
          <svg
            className="w-6 h-6"
            style={{ width: 24, height: 24 }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      <Navigation
        variant="mobile"
        isOpen={mobileOpen}
        onLinkClick={closeMobileMenu}
      />
    </nav>
  );
};

export default Header;
